<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="名称">
                  <el-input  v-model="queryForm.brandName"></el-input>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getWashProductBrandList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addWashProductBrand"
        >新建</el-button>
        <el-button
          type="warning"
          plain
          size="small"
          icon="el-icon-edit"
          :disabled="multipleSelection.length != 1"
          @click="editWashProductBrand(null)"
        >修改</el-button>
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteWashProductBrand(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
        <span
          class="icon-box"
          @click="refreshWashProductBrandList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="washProductBrandList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="brandName"
        label="名称"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="sort"
        label="排序"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="shortcut"
        label="快捷键"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="createTime"
        label="创建时间"
        width="180"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="checkWashProductBrand(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
            <div @click="editWashProductBrand(scop.row.id)">
              <Icon size="16">
                <Edit24Regular />
              </Icon>
              <span class="operation-label">修改</span>
            </div>
            <div @click="deleteWashProductBrand(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="washProductBrandStates[washProductBrandState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="washProductBrand"
          ref="washProductBrandForm"
          :rules="rules"
          label-width="120px"
          :inline="true"
          size="small"
        >
          <el-form-item
            label="名称"
            prop="brandName"
          >
            <el-input
              size="small"
              v-model="washProductBrand.brandName"
              :disabled="washProductBrandState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="排序"
            prop="sort"
          >
            <el-input
              size="small"
              v-model="washProductBrand.sort"
              :disabled="washProductBrandState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="快捷键"
            prop="shortcut"
          >
            <el-input
              size="small"
              v-model="washProductBrand.shortcut"
              :disabled="washProductBrandState == 'check'"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="washProductBrandState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetWashProductBrandList();
                    this.getWashProductBrandList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetWashProductBrandList();
                    this.getWashProductBrandList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     brandName: '', //名称
                     sort: '', //排序
                     shortcut: '', //快捷键
                },
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                washProductBrandState: 'add',
                washProductBrandStates: {
                    add: '新建品牌设置',
                    check: '查看品牌设置',
                    edit: '修改品牌设置'
                },

                multipleSelection: [],
                washProductBrandList: [],
                washProductBrand: {
                    id: '', //ID
                    brandName: '', //名称
                    sort: '', //排序
                    shortcut: '', //快捷键
                    createTime: '', //创建时间
                },
                btnLoading: false,

                rules: {
                    id: [{ required: true, message: 'ID不能为空', trigger: 'blur' }],
                    brandName: [{ required: true, message: '名称不能为空', trigger: 'blur' }],
                    sort: [{ required: true, message: '排序不能为空', trigger: 'blur' }],
                }
            };
        },
        created() {
            this.getWashProductBrandList();
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            resetWashProductBrandList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.washProductBrandList = [];
            },
            resetDialog() {
                this.washProductBrandState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      id: '', //ID
                      brandName: '', //名称
                      sort: '', //排序
                      shortcut: '', //快捷键
                      createUserId: '', //创建者
                      createTime: '', //创建时间
                      updateUserId: '', //更新者
                      updateTime: '', //更新时间
                      deleteFlag: '', //是否删除 0 正常 1 删除
                };
                this.getWashProductBrandList();
            },
            closeDialog() {
                this.showDialog = false
                this.washProductBrand = {
                      id: '', //ID
                      brandName: '', //名称
                      sort: '', //排序
                      shortcut: '', //快捷键
                      createUserId: '', //创建者
                      createTime: '', //创建时间
                      updateUserId: '', //更新者
                      updateTime: '', //更新时间
                      deleteFlag: '', //是否删除 0 正常 1 删除
                };
            },
            submitForm() {
                if (this.washProductBrandState == 'add') {
                    this.$refs.washProductBrandForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/wash/productbrand/add`,{ ...this.washProductBrand }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetWashProductBrandList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.washProductBrandState == 'edit') {
                    this.$refs.washProductBrandForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/wash/productbrand/edit`,{ ...this.washProductBrand }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetWashProductBrandList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addWashProductBrand() {
                this.showDialog = true;
                this.washProductBrandState = 'add';
            },
            checkWashProductBrand(washProductBrandId) {
                console.log(washProductBrandId);
                this.currentWashProductBrandId = washProductBrandId;

                this.getWashProductBrandById();
                this.showDialog = true;
                this.washProductBrandState = 'check';
            },
            editWashProductBrand(washProductBrandId) {
                console.log('washProductBrand', washProductBrandId);
                if (washProductBrandId) {
                    this.currentWashProductBrandId = washProductBrandId;
                    this.getWashProductBrandById();
                } else {
                    this.washProductBrand = { ...this.washProductBrand, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.washProductBrandState = 'edit';
            },
            deleteWashProductBrand(washProductBrandId) {
                let ids = '';
                if (washProductBrandId) {
                    ids = washProductBrandId;
                } else {
                    ids = this.multipleSelection.map((washProductBrand) => washProductBrand.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/wash/productbrand/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetWashProductBrandList();
                                this.getWashProductBrandList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshWashProductBrandList() {
                this.resetWashProductBrandList();
                this.getWashProductBrandList();
            },
            getWashProductBrandList(query = {}) {
                this.loading = true;
                get(`/wash/productbrand/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.washProductBrandList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getWashProductBrandById() {
                get(`/wash/productbrand/get`,{ id: this.currentWashProductBrandId }).then((res) =>{
                    if(res.success){
                      this.washProductBrand = { ...this.washProductBrand, ...res.washProductBrand };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportWashProductBrandList() {
                //this.btnLoading = true;
                exprotExcel(`/wash/productbrand/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/wash/productbrand/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/wash/productbrand/importData`,formData);
              this.refreshWashProductBrandList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getWashProductBrandList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getWashProductBrandList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>